import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cogoToast from 'cogo-toast';
import React, { useContext, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import CurrencyInput from 'react-currency-input-field';
import { Row } from 'reactstrap';
import Spinner from 'reactstrap/lib/Spinner';
import ThemeBackground from '../../../components/common/ThemeBackground';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import MainTable from '../../../components/tables/MainTable';
import { EnvironmentContext } from '../../../context/Context';
import { getTodayStr } from '../../../helpers/dateFormatters';
import { currencyFormat as currencyNumberFormat, formatterId } from '../../../helpers/formatters';
import numToWord from '../../../helpers/numToWord';
import { currencyFormat } from '../../../helpers/tableFormatters';
import { recaudoServices } from '../../../services';
import RecaudoLoteModal from '../modals/RecaudoLoteModal';
import { RecaudoContext } from '../RecaudoContext';
import LoteInfo from '../sections/LoteInfo';

const RecaudoLote = () => {
    const context = useContext(RecaudoContext);
    const environment = useContext(EnvironmentContext);
    const { loading, creditsPag, pagSelected, showModalLote, toggleModalLote, handleSaveLote, onCancelLote } = context;
    const [requesting, setRequesting] = useState(false);
    const [showModal, setShowModal] = useState();
    const [creditSelected, setCreditSelected] = useState();
    const [recaudos, setRecaudos] = useState(0);
    const [numRecaudos, setNumRecaudos] = useState(0);
    const [dataTable, setDataTable] = useState([]);

    const [success, setSuccess] = useState();

    const [invoiceProps, setInvoiceProps] = useState();

    const columns = [
        {
            dataField: 'credito',
            text: 'Crédito',
            headerClasses: 'border-0',
            align: 'left',
            classes: 'border-0 py-2 align-middle',
            sort: true,
        },
        {
            dataField: 'identificacion',
            text: 'Identificación',
            headerClasses: 'border-0',
            classes: 'border-0 py-2 align-middle',
            sort: true,
            sortFunc: (a, b, order) => order === 'asc' ? Number(a) - Number(b) : Number(b) - Number(a),
        },
        {
            dataField: 'nombre',
            text: 'Nombre',
            headerClasses: 'border-0',
            classes: 'border-0 py-2 align-middle',
            sort: true,
        },
        {
            dataField: 'apellido',
            text: 'Apellido',
            headerClasses: 'border-0',
            classes: 'border-0 py-2 align-middle',
            sort: true,
        },
        {
            dataField: 'periodo',
            text: 'Periodo',
            headerClasses: 'border-0',
            classes: 'border-0 py-2 align-middle',
            sort: true
        },
        {
            dataField: 'fechaCorte',
            text: 'Fecha Corte',
            headerClasses: 'border-0',
            classes: 'border-0 py-2 align-middle',
            sort: true
        },
        {
            dataField: 'valorCuota',
            text: 'Valor Cuota',
            headerClasses: 'border-0 text-right',
            align: 'right',
            classes: 'border-0 py-2 align-middle',
            sort: true,
            formatter: (value, row) => (
                <div className="d-flex align-items-center justify-content-end">
                    <span>{currencyFormat(value)}</span>
                    <button
                        className="btn btn-sm btn-link p-0 ml-2 text-primary"
                        onClick={() => onCopyValorCuota(row)}
                        title="Copiar a Valor Recaudo"
                    >
                        <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </div>
            ),
        },
        /*{
            dataField: 'intereses',
            text: 'Abono Interés',
            headerClasses: 'border-0 text-right',
            align: 'right',
            classes: 'border-0 py-2 align-middle',
            formatter: (dataField) => moneyFormatter(dataField),
        },
        {
            dataField: 'capital',
            text: 'Abono Capital',
            headerClasses: 'border-0 text-right',
            align: 'right',
            classes: 'border-0 py-2 align-middle',
            formatter: (dataField) => moneyFormatter(dataField),
        },*/
        {
            dataField: '',
            text: 'Valor Recaudo',
            headerClasses: 'border-0 text-center',
            classes: 'border-0 py-2 text-left align-middle',
            formatter: (dataField, selected) => currencyInputFormatter(selected),
        },
    ];

    useEffect(() => {
        setRecaudos(0);
        setNumRecaudos(0);
        setCreditSelected(null);
        loadDatatable();
    }, [creditsPag]);

    // El componente no se desmonta entre lotes, así que sin este reinicio el modal
    // se vuelve a abrir mostrando el "Recaudo Exitoso!" del lote anterior y el
    // usuario nunca ve el formulario ni se envía nada al servidor.
    useEffect(() => {
        if (!showModalLote) return;
        setSuccess(false);
        setInvoiceProps(null);
    }, [showModalLote]);

    const moneyFormatter = value => {
        return (
            <CountUp end={value} duration={1} prefix="$" separator="." decimal="," decimals={2} style={{ fontSize: '1rem' }} />
        )
    }

    const onCopyValorCuota = (selected) => {
        const key = "recaudo-" + selected.credito + "-" + selected.periodo;
        localStorage.setItem(key, String(selected.valorCuota));
        setDataTable(prev => {
            const tempData = [...prev];
            const index = tempData.findIndex(c => c.credito === selected.credito && c.periodo === selected.periodo);
            if (index === -1) return prev;
            tempData[index] = { ...tempData[index], recaudo: selected.valorCuota };
            return tempData;
        });
        setTimeout(() => {
            const input = document.getElementById(selected.credito + "-" + selected.periodo);
            if (input) input.focus();
        }, 0);
    }

    const currencyInputFormatter = selected => {
        return (
            <div className='pl-4'>
                <CurrencyInput
                    className="form-control pl-2 text-right"
                    allowNegativeValue={false}
                    id={selected.credito + "-" + selected.periodo}
                    prefix='$'
                    intlConfig={{ locale: 'es-CO', currency: 'COP' }}
                    onValueChange={(e) => {
                        var key = "recaudo-" + selected.credito + "-" + selected.periodo;
                        if (e) {
                            setCreditSelected({ id: selected.credito, value: e, periodo: selected.periodo });
                            localStorage.setItem(key, e.replaceAll(' ', '').replace('$', '.').replace('.', '').replace(',', '.'));
                        } else {
                            localStorage.removeItem(key);
                            setDataTable(prev => prev.map(row =>
                                row.credito === selected.credito && row.periodo === selected.periodo
                                    ? { ...row, recaudo: null }
                                    : row
                            ));
                        }
                    }}
                    allowDecimals={false}
                    maxLength={20}
                    placeholder="$ 0"
                    tabIndex="5"
                    value={selected.recaudo} />
            </div>
        )
    }

    useEffect(() => {
        if (!creditSelected) return;
        onChangeRecaudo(creditSelected);
    }, [creditSelected])

    useEffect(() => {
        if (!dataTable || !dataTable[0]) return;
        const creditsRecaudos = dataTable.filter(c => c.recaudo > 0);

        const tempRecaudo = creditsRecaudos[0] ? creditsRecaudos.map(c => c.recaudo).reduce((a, b) => a + b) : 0;
        const tempNumRecaudos = creditsRecaudos.length;
        setRecaudos(tempRecaudo);
        setNumRecaudos(tempNumRecaudos);
    }, [dataTable])

    const loadDatatable = data => {
        let tempData;
        if (data) {
            tempData = [...dataTable];
            const index = dataTable.findIndex(credit => credit.credito == data.id && credit.periodo == data.periodo);
            //const selected = tempData[index];
            const recaudoValue = data.value == null ? null
                : Number(data.value.replaceAll(' ', '').replace('$', '.').replace('.', '').replace(',', '.'));
            /*const intereses = recaudoValue >= selected.saldo_interes
                ? selected.saldo_interes
                : recaudoValue;
            const capital = recaudoValue > selected.saldo_interes
                ? recaudoValue - selected.saldo_interes
                : 0;*/
            const updatedItem = {
                ...tempData[index],
                //intereses,
                //capital,
                recaudo: recaudoValue
            };
            tempData[index] = updatedItem
        } else {
            tempData = creditsPag.map((credit, index) => {
                const recaudoValue = localStorage.getItem("recaudo-" + credit.credito + "-" + credit.periodo);
                return {
                    ...credit,
                    index,
                    intereses: 0,
                    capital: 0,
                    recaudo: recaudoValue ? Number(recaudoValue) : null
                }
            })
        }
        setDataTable(tempData);
    }

    const onChangeRecaudo = (data, table) => {
        loadDatatable(data);
    }

    const createInvoiceProps = (payload) => {
        const selectedConcept = payload.idTesoreria
            ? environment.cashLoteConcepts.filter(concept => concept.conceptotesoreria == payload.conceptoTesoreria)
            : [];
        const total = payload.recaudos.map(recaudo => recaudo.valorRecaudo).reduce((a, b) => a + b)
        const montoWord = numToWord(total)


        const tempOwnProps = {
            client: pagSelected.razonSocial,
            clientTypeId: pagSelected.tipoIdentificacion,
            clientId: pagSelected.identificacion ? formatterId(Number(pagSelected.identificacion)) : "",
            serial: payload.consecutivo,
            ciudad: payload.ciudad,
            amount: currencyNumberFormat(total || 0),
            concept: selectedConcept[0] ? selectedConcept[0].nombre : "",
            sumWord: montoWord || "",
            checkCash: payload.modalidadPago == 1,
            checkWireTransfer: payload.modalidadPago == 2,
            checkPSE: false,
            checkCheque: payload.modalidadPago == 3,
            date: payload.fecha ? payload.fecha.split('-') : getTodayStr().split('-'),
            observations: payload.observacion
        }
        setInvoiceProps(tempOwnProps)
    }

    const handleCleanLote = () => {
        setRecaudos(0);
        setNumRecaudos(0);
        setDataTable([]);
        onCancelLote();
    }

    const onRecaudar = async paymentData => {
        const selectedRecaudos = dataTable.filter(c => c.recaudo/* > 0*/)
        if (selectedRecaudos.length < 1 || !pagSelected) {
            cogoToast.warn("No hay valores para recaudar",
                { position: 'bottom-left', heading: 'Sin Valores' });
            return;
        }
        setRequesting(true);
        const payload = {
            idPagaduria: pagSelected.id,
            recaudos: selectedRecaudos.map(r => ({
                idPrestamo: r.prestamo,
                valorRecaudo: r.recaudo,
                abonoInteres: r.intereses,
                abonoCapital: r.capital,
                periodo: r.periodo
            })),
            tipoRecaudo: 2,
            ...paymentData,
        }
        //console.log(payload);
        const response = await recaudoServices.setRecaudoLote(payload);
        if (!response || response.error) {
            cogoToast.error(response?.msg || "No se logro completar la solicitud de recaudo por lote",
                { position: 'bottom-left', heading: 'Error' });
            return;
        }
        selectedRecaudos.forEach(r => {
            localStorage.removeItem("recaudo-" + r.credito + "-" + r.periodo);
        });
        handleSuccess({
            ...payload,
            consecutivo: response.objResponse.consecutivo,
            ciudad: response.objResponse.ciudad
        });
    }

    const handleSuccess = (payload) => {
        // toggle(true);
        createInvoiceProps(payload);
        setSuccess(true);
        setRequesting(false);
    }

    const onOk = () => {
        handleSaveLote();
        setRequesting(false);
        loadDatatable();
    }

    const handleSaveClick = (values) => {
        const parsedValues = { ...values, amount: values.amount.replaceAll(',', '.') }
        const expectAmount = values.amount ? Number(parsedValues.amount) : 0;
        const selectedRecaudos = dataTable.filter(c => c.recaudo/* > 0*/)
        if (!selectedRecaudos[0]) {
            cogoToast.warn("No existen valores por recaudar",
                { position: 'bottom-left', heading: 'Valores Requeridos' });
            return;
        }
        const selectedCount = selectedRecaudos.length;
        const selectedAmount = selectedRecaudos.map(item => item.recaudo).reduce((a, b) => a + b)

        if (selectedCount != values.cant || selectedAmount != expectAmount) {
            cogoToast.warn("Los valores esperados no coinciden con los seleccionados",
                { position: 'bottom-left', heading: 'Valores no coinciden' });
            return;
        }

        toggleModalLote();
    }

    return (
        <>
            {requesting ? (
                <Row className="py-4 d-flex justify-content-center">
                    <Spinner color="primary" />
                </Row>
            ) : (
                <>
                    <RecaudoLoteModal
                        open={showModalLote}
                        data={{ total: recaudos, numRecaudos }}
                        toggle={toggleModalLote}
                        success={success}
                        onSubmit={onRecaudar}
                        invoiceProps={invoiceProps}
                        onOk={onOk}
                    />
                    <LoteInfo context={RecaudoContext} handleCleanLote={handleCleanLote} handleSaveClick={handleSaveClick} />
                    <MainTable
                        data={dataTable}
                        columns={columns.map(col => ({ ...col, headerStyle: { backgroundColor: "rgb(0, 72, 162)", color: "#fff", position: "sticky", top: 70, zIndex: 1 } }))}
                        keyField="index"
                        className="px-2"
                        loading={loading}
                        stickyHeader
                        noSearch
                        noAdd
                    />
                    <div className='card mt-3 w-100 p-4 d-flex flex-row justify-content-between'>
                        <ThemeBackground color='info' />
                        <DetailRow title="Cantidad" className="mb-1">
                            <div className='display-4 fs-4 font-weight-normal text-center text-sans-serif text-info'>
                                {numRecaudos}
                            </div>
                        </DetailRow>
                        <DetailRow title="Total a recaudar" className="mb-1">
                            <div className='display-4 fs-4 font-weight-normal text-sans-serif text-info'>
                                <CountUp end={recaudos} duration={1} prefix="$" separator="." decimal="," decimals={2} />
                            </div>
                        </DetailRow>
                    </div>
                </>
            )}

        </>
    )
}

export default RecaudoLote